import { Divider } from '@advanza/ui'
import clsx from 'clsx'
import ChurnReasonThemesList from 'components/churnReasonThemes/ChurnReasonThemesList'
import PremiumCancelProfileChecksList from 'components/churnReasonThemes/PremiumCancelProfileChecksList'
import Page from 'components/ui/Page'
import { useSearchParams } from 'react-router-dom'

type TabId = 'themes' | 'checks'

const TABS: { id: TabId; label: string; hint: string }[] = [
    { id: 'themes', label: 'Themes', hint: 'Review and approve the themes the AI created' },
    {
        id: 'checks',
        label: 'Profile checks',
        hint: 'Does the confirmed reason match the provider’s behaviour?',
    },
]

const ChurnReasonThemesPage = () => {
    // Tab lives in the URL so views are shareable and survive a refresh.
    const [searchParams, setSearchParams] = useSearchParams()
    const activeTab = searchParams.get('tab') === 'checks' ? 'checks' : 'themes'

    const setTab = (tab: TabId) => {
        setSearchParams(
            (prev) => {
                prev.set('tab', tab)
                return prev
            },
            { replace: true },
        )
    }

    return (
        // @ts-ignore
        <Page title="Churn Reason Themes">
            <div className="container">
                <Divider />
                <h1>Churn Reason Themes</h1>
                <p>
                    Themes the cancel reason AI created from providers&apos; own words. A theme is
                    only shown to the provider who seeded it until it is approved here. The profile
                    checks compare every pro dashboard cancellation with what the platform observed
                    about the provider; they are never shown to the provider.
                </p>
                <div className="mt-6 flex gap-1 border-b border-[#dddddd]">
                    {TABS.map((tab) => (
                        <button
                            key={tab.id}
                            type="button"
                            onClick={() => setTab(tab.id)}
                            className={clsx(
                                '-mb-px border-b-2 px-4 py-3 text-left transition',
                                activeTab === tab.id
                                    ? 'border-brand-500'
                                    : 'border-base-transparent hover:bg-neutral-50',
                            )}>
                            <span
                                className={clsx(
                                    'block text-md font-semibold',
                                    activeTab === tab.id ? 'text-brand-500' : 'text-neutral-700',
                                )}>
                                {tab.label}
                            </span>
                            <span className="block text-sm text-neutral-400">{tab.hint}</span>
                        </button>
                    ))}
                </div>
                <div className="mt-6">
                    {activeTab === 'themes' ? (
                        <ChurnReasonThemesList />
                    ) : (
                        <PremiumCancelProfileChecksList />
                    )}
                </div>
            </div>
        </Page>
    )
}

export default ChurnReasonThemesPage
